import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../components/widgets';
import { IconVariants } from '../../components/foundations/Icon';
import css from './ImproveActions.css';
import { IMPROVE_BUTTON_TEXT, REVERT_BUTTON_TEXT } from '../consts';

const ImproveActions = ({
    isImproving,
    canRevert,
    shouldDisableImprove,
    onImprove,
    onRevert,
    improveButtonText = IMPROVE_BUTTON_TEXT,
}) => {
    return (
        <div className={css.container}>
            <Button
                text={improveButtonText}
                onClick={onImprove}
                type="link"
                Icon={!isImproving && 'ai-line'}
                iconVariant={shouldDisableImprove ? IconVariants.LIGHT : IconVariants.ACTIVE}
                className={css.action}
                disabled={shouldDisableImprove}
                showSpinner={isImproving}
            />
            {canRevert && (
                <Button
                    text={REVERT_BUTTON_TEXT}
                    onClick={onRevert}
                    type="link"
                    Icon="arrow-back-up"
                    iconVariant={IconVariants.ACTIVE}
                    className={css.action}
                />
            )}
        </div>
    );
};

ImproveActions.propTypes = {
    isImproving: PropTypes.bool,
    canRevert: PropTypes.bool,
    shouldDisableImprove: PropTypes.bool,
    onImprove: PropTypes.func.isRequired,
    onRevert: PropTypes.func.isRequired,
    improveButtonText: PropTypes.string,
};

export default ImproveActions;
